import React, { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import { APP_TOOLTIP_ID } from 'js/config/consts';

import './ActionButton.css';

interface ActionButtonProps {
  id?: string;
  linkTo?: string;
  disabled?: boolean;
  onClick?: (event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => void;
  children?: ReactNode;
  datatip?: string;
  ariaHasPopup?: boolean;
  ariaExpanded?: boolean;
  tight?: boolean;
  small?: boolean;
  appearDisabled?: boolean;
  appearAsButton?: boolean;
}

const ActionButton: React.FC<ActionButtonProps> = ({
  id,
  linkTo,
  disabled = false,
  onClick,
  datatip,
  ariaHasPopup = false,
  ariaExpanded = false,
  children,
  tight,
  small,
  appearDisabled,
  appearAsButton
}) => {
  const classes = classNames('ActionButton', {
    'ActionButton--appearDisabled': appearDisabled,
    'ActionButton--tight': tight,
    'ActionButton--small': small,
    'ActionButton--asButton': appearAsButton
  });

  return linkTo ? (
    <Link
      to={linkTo || '#'}
      data-for={APP_TOOLTIP_ID}
      data-tip={datatip}
      aria-label={datatip}
      id={id}
      className={classes}
      onClick={onClick}
      aria-disabled={disabled}
      tabIndex={disabled ? -1 : 0}
      role="button"
      aria-haspopup={ariaHasPopup}
      aria-expanded={ariaExpanded}
    >
      {children}
    </Link>
  ) : (
    <button
      data-for={APP_TOOLTIP_ID}
      data-tip={datatip}
      aria-label={datatip}
      id={id}
      className={classes}
      onClick={onClick}
      aria-disabled={disabled}
      tabIndex={disabled ? -1 : 0}
      aria-haspopup={ariaHasPopup}
      aria-expanded={ariaExpanded}
    >
      {children}
    </button>
  );
};

export default ActionButton;
